import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal from "common/components/Modal/Modal"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { globalSelector } from "routes/globalSlice"
import { FormikDocumentsProps } from "../CreacionDocumento"
import { getNumberDocument } from "../FormCreacionDocumento"
import {
  esFechaOperacionValida,
  MODES_DOCUMENTOS,
  TYPES_DOCUMENTOS,
} from "../constant"
import { FormasPago } from "../hooks/ConvertirDocumento/ConvertirDocumento"

const ModalSucessCreateDocumento = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { formasPago } = useSelector(globalSelector)
  const serieAndNumero =
    values?.serie && values?.numero
      ? `${values.serie}-${values.numero}`
      : values?.numero ?? values?.serie ?? ""

  const nuevoAndConvertir = async (modeConvertir: boolean) => {
    if (modeConvertir) {
      if (values.documentoType.type === TYPES_DOCUMENTOS.PEDIDO) {
        setFieldValue("documentoType.type", TYPES_DOCUMENTOS.ALBARAN)
        setFieldValue(
          "documentosComercialesAsociados",
          `${t("documentos.validar.select.orderLabel")}: ${serieAndNumero}`
        )
      }
      if (values.documentoType.type === TYPES_DOCUMENTOS.ALBARAN) {
        setFieldValue("config.sinValorar", false)
        setFieldValue("documentoType.type", TYPES_DOCUMENTOS.FACTURA)
        setFieldValue(
          "documentosComercialesAsociados",
          `${t("documentos.validar.select.deliveryLabel")}: ${serieAndNumero}`
        )
        setFieldValue("fechaEmision", new Date())
        const fechaVencimientoDate = new Date()
        if (values.diasPago) {
          fechaVencimientoDate.setDate(
            fechaVencimientoDate.getDate() + (values.diasPago ?? 0)
          )
        }
        setFieldValue("fechaVencimiento", fechaVencimientoDate)
        const isValidaFechaOperacion = esFechaOperacionValida(
          new Date(values.fechaOperacion)
        )
        !isValidaFechaOperacion && setFieldValue("fechaOperacion", null)
      }
      if (values.documentoType.type === TYPES_DOCUMENTOS.PRESUPUESTO) {
        setFieldValue("documentoType.type", TYPES_DOCUMENTOS.PEDIDO)
        setFieldValue(
          "documentosComercialesAsociados",
          `${t("documentos.validar.select.quotationLabel")}: ${serieAndNumero}`
        )
      }
      setFieldValue(
        "modals.showOnCreateDocumentModal",
        !values.modals.showOnCreateDocumentModal
      )
    } else {
      const formaPagoDescription = formasPago?.find(
        (forma: FormasPago) =>
          values?.config?.preferenceContat?.formaPago === forma.id
      )?.description

      const fechaVencimientoDate = new Date()
      if (values?.config?.preferenceContat?.vencimientoDias) {
        fechaVencimientoDate.setDate(
          fechaVencimientoDate.getDate() +
            values?.config?.preferenceContat?.vencimientoDias
        )
      }

      setFieldValue("conceptos", [])
      setFieldValue(
        "modals.showOnCreateDocumentModal",
        !values?.modals?.showOnCreateDocumentModal
      )
      setFieldValue("numero", values.numero + 1)
      setFieldValue("observaciones", null)
      setFieldValue(
        "descuento",
        values?.config?.preferenceContat?.descuento ?? null
      )

      setFieldValue("diasPago", values?.config?.preferenceContat?.diaDePago)
      setFieldValue(
        "formaPago",
        values?.config?.preferenceContat?.formaPago ?? null
      )
      setFieldValue(
        "formaPagoDescription",
        values?.config?.preferenceContat?.formaPago
          ? formaPagoDescription
          : null
      )
      setFieldValue("fechaOperacion", null)
      setFieldValue("fechaEmision", new Date())
      setFieldValue(
        "fechaVencimiento",
        values?.config?.preferenceContat?.vencimientoDias
          ? fechaVencimientoDate
          : new Date()
      )
      setFieldValue("ficheros", [])
      setFieldValue("totales", {
        descuentoValor: 0,
        impuestosAgrupados: [],
        retencionTotal: 0,
        subtotal: 0,
        totalValor: 0,
      })
      setFieldValue("retencionTipoId", null)
      setFieldValue("retencionPorcentaje", null)
      setFieldValue("config.sinValorar", false)
      setFieldValue("config.cuentaContableMultiple", null)
      setFieldValue("formaPagoIban", null)
      // TODO: cuentaContableCategoriaId o cuentaContableId
      // setFieldValue("cuentaContableCategoriaId", null)
      setFieldValue("documentosComercialesAsociados", null)
      setFieldValue("total", 0)
      setFieldValue("cantidadTotalArticulos", 0)
      setFieldValue("embalajes", [])
      setFieldValue("lugarEntrega", null)
      setFieldValue("archivosAdjuntos", [])
      const numero = await getNumberDocument(
        values.documentoType.type,
        values.serie
      )
      setFieldValue("numero", numero)
      setFieldValue("numeroDocumento", "")
    }
  }
  const getButtonLabel = (type: string) => {
    switch (type) {
      case TYPES_DOCUMENTOS.PRESUPUESTO:
        return TYPES_DOCUMENTOS.PEDIDO
      case TYPES_DOCUMENTOS.PEDIDO:
        return t("newDoc.albaran.deliveryLabel")
      case TYPES_DOCUMENTOS.ALBARAN:
        return TYPES_DOCUMENTOS.FACTURA
      default:
        return ""
    }
  }

  return (
    <Modal
      showHeader={false}
      size='small'
      draggable
      maskClassName='!tw-z-40 !tw-rounded-md'
      onHide={() =>
        setFieldValue(
          "modals.showOnCreateDocumentModal",
          !values.modals.showOnCreateDocumentModal
        )
      }
      className='tw-rounded-lg'
      visible={values?.modals?.showOnCreateDocumentModal}
    >
      <div className='tw-w-full tw-mt-10 tw-h-full tw-flex tw-flex-col tw-items-center tw-px-12'>
        <div className='tw-w-full tw-h-32 tw-flex tw-flex-row tw-justify-center tw-items-center tw-rounded-full tw-p-5 '>
          <div className='tw-h-32 tw-w-32 tw-flex tw-flex-row tw-justify-center tw-items-center tw-rounded-full tw-p-5 tw-bg-neutral-10'>
            <div className='tw-flex tw-flex-row tw-w-full tw-h-full tw-items-center tw-justify-center tw-rounded-full tw-p-4 !tw-bg-simple-10 tw-border !tw-border-neutral-25'>
              <div className='tw-text-secondary tw-w-full tw-h-full tw-flex tw-flex-row tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-secondary'>
                <FontAwesomeIcon
                  icon={["fal", "check"]}
                  className='tw-w-6 tw-h-6'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='tw-w-full tw-mt-10 tw-text-center tw-text-wrap'>
          {t("nextDoc.docCreateExit")}
        </div>
        <div className='tw-w-full tw-mt-10 tw-flex tw-flex-col'>
          {values.documentoType.type !== TYPES_DOCUMENTOS.FACTURA &&
            values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA &&
            !(
              values.documentoType.type === TYPES_DOCUMENTOS.ALBARAN &&
              values.documentoType.mode === MODES_DOCUMENTOS.COMPRA
            ) && (
              <ButtonPrimeReact
                className='tw-h-10 tw-flex tw-justify-center tw-items-center !tw-simple-10 !tw-bg-secondary hover:!tw-bg-secondary-over hover:!tw-shadow !tw-border-none tw-cursor-pointer'
                onClick={() => nuevoAndConvertir(true)}
              >
                {t("crear.facturaRec.modal.convertLabel")}
                {getButtonLabel(values.documentoType.type)}
              </ButtonPrimeReact>
            )}
          <ButtonPrimeReact
            onClick={() => {
              setFieldValue(
                "modals.showOnCreateDocumentModal",
                !values.modals.showOnCreateDocumentModal
              )

              if (values.documentoType.type === TYPES_DOCUMENTOS.FACTURA)
                history.push(ROUTES.FACTURAS)
              if (values.documentoType.type === TYPES_DOCUMENTOS.PEDIDO)
                history.push(ROUTES.PEDIDOS)
              if (values.documentoType.type === TYPES_DOCUMENTOS.ALBARAN) {
                history.push(ROUTES.ALBARANES)
              }
              if (values.documentoType.type === TYPES_DOCUMENTOS.PRESUPUESTO)
                history.push(ROUTES.PRESUPUESTOS)
              if (values.documentoType.type === TYPES_DOCUMENTOS.PROFORMA)
                history.push(ROUTES.FACTURAS_PROFORMA)
            }}
            className='tw-mt-4 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-simple-10 !tw-bg-primary hover:!tw-bg-primary-over hover:!tw-shadow !tw-border-none tw-cursor-pointer'
          >
            {t("crear.facturaRec.modal.endLabel")}
          </ButtonPrimeReact>
          <ButtonPrimeReact
            onClick={() => {
              nuevoAndConvertir(false)
              setFieldValue("modoEditarBorrador", false)
            }}
            className='tw-my-4 tw-font-medium tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-bg-simple-10 hover:!tw-bg-neutral-10 hover:!tw-shadow !tw-border-none !tw-bg-transparent tw-cursor-pointer'
          >
            {t("crear.facturaRec.modal.createNewLabel")}
          </ButtonPrimeReact>
        </div>
      </div>
    </Modal>
  )
}

export default ModalSucessCreateDocumento
